module.exports = __webpack_public_path__ + "img/enter.18c1dfed.png";